import { AppState } from './state.model';
import { Reducer, combineReducers } from 'redux';
import { FileReducer } from './file/file-reducer';
import { CommonReducer } from './common/common-reducer';
import { AuthReducer } from './auth/auth-reducer';
import { CustomerReducer } from './customer/customer-reducer';
import { VehicleReducer } from './vehicle-store/vehicle-reducer';
import { StepReducer } from './steps-store/step-reducer';
import { initialAdminState } from './admin-store/admin-state.model';
import { AdminReducer } from './admin-store/admin-reducer';
import { initialUserRoleState } from './user-role/user-role-state.model';
import { UserRoleReducer } from './user-role/user-role-reducer';
import { initialFile } from './file/file-state.model';
import { initialCommon } from './common/common-state.model';
import { initialCustomerState } from './customer/customer-state.model';
import { initialVehicleState } from './vehicle-store/vehicle-state.model';
import { initialSelectedVehicleState } from './selected-vehicle-store/selected-vehicle-state.model';
import { initialStepState } from './steps-store/step-state.model';
import { ApiResponseReducer } from './api-response/api-response-reducer';
import { tassign } from 'tassign';
import { UpdateReducer } from './update-customer/update-reducer';
import { initialApiResponseState } from './api-response/api-response-state.model';
import { initialUpdateState } from './update-customer/update-state.model';
import { SelectedVehicleReducer } from './selected-vehicle-store/selected-vehicle-reducer';

const appReducer: Reducer<AppState> = combineReducers({
  file: FileReducer,
  auth: AuthReducer,
  common: CommonReducer,
  customer: CustomerReducer,
  vehicle: VehicleReducer,
  selectedVehicle: SelectedVehicleReducer,
  api: ApiResponseReducer,
  step: StepReducer,
  admin: AdminReducer,
  update: UpdateReducer,
  userRole: UserRoleReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    state = {
      file: initialFile,
      common: initialCommon,
      customer: initialCustomerState,
      vehicle: initialVehicleState,
      selectedVehicle: initialSelectedVehicleState,
      api: initialApiResponseState,
      step: initialStepState,
      admin: initialAdminState,
      update: initialUpdateState,
      userRole: initialUserRoleState,
      auth: tassign(state.auth, { guid: '' }),
    };
  }
  return appReducer(state, action);
};






